import React, { useEffect } from 'react';
import ChartCard from './ChartCard';

// Define the types for our data
type TimeSeriesDataPoint = {
  time: string;
  p50: number;
  p95: number;
  p99: number;
  avg: number;
};

interface TimeSeriesData {
  [key: string]: TimeSeriesDataPoint[];
}

interface ChartsGridProps {
  timeRange?: string;
}

const ChartsGrid: React.FC<ChartsGridProps> = ({ timeRange = 'Last 1h' }) => {
  // Log the time range when the component mounts or the time range changes
  useEffect(() => {
    console.log('ChartsGrid received time range:', timeRange);
  }, [timeRange]);

  // Sample data for charts - mostly baseline with unique patterns per percentile
  const timeSeriesData: TimeSeriesData = {
    "Last 10m": [
      { time: '08:00', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:01', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:02', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:03', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:04', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:05', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:06', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '08:07', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:08', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:09', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:10', p50: 0, p95: 1, p99: 2, avg: 0 },
    ],
    "Last 30m": [
      { time: '08:00', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:01', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:02', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:03', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:04', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:05', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:06', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '08:07', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:08', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:09', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:10', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:11', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:12', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:13', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:14', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:15', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:16', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:17', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:18', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:19', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:20', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:21', p50: 1, p95: 6, p99: 25, avg: 2 },
      { time: '08:22', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:23', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:24', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:25', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:26', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:27', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:28', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:29', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:30', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:00', p50: 0, p95: 2, p99: 4, avg: 0 }
    ],
    "Last 1h": [
      { time: '08:00', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:01', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:02', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:03', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:04', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:05', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:06', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '08:07', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:08', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:09', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:10', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:11', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:12', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:13', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:14', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:15', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:16', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:17', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:18', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:19', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:20', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:21', p50: 1, p95: 6, p99: 25, avg: 2 },
      { time: '08:22', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:23', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:24', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:25', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:26', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:27', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:28', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:29', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:30', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:31', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:32', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '08:33', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:34', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:35', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:36', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:37', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:38', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:39', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:40', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:41', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:42', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:43', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:44', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:45', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:46', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:47', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '08:48', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:49', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:50', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:51', p50: 0, p95: 3, p99: 12, avg: 1 },
      { time: '08:52', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:53', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:54', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:55', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:56', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:57', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:58', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:59', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:00', p50: 0, p95: 2, p99: 4, avg: 0 }
    ],
    "Last 6h": [
      { time: '08:00', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:01', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:02', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:03', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:04', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:05', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:06', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '08:07', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:08', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:09', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:10', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:11', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:12', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:13', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:14', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:15', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:16', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:17', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:18', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:19', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:20', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:21', p50: 1, p95: 6, p99: 25, avg: 2 },
      { time: '08:22', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:23', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:24', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:25', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:26', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:27', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:28', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:29', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:30', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:31', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:32', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '08:33', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:34', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:35', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:36', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:37', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:38', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:39', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:40', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:41', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:42', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:43', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:44', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:45', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:46', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:47', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '08:48', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:49', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:50', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:51', p50: 0, p95: 3, p99: 12, avg: 1 },
      { time: '08:52', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:53', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:54', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:55', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:56', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:57', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:58', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '08:59', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:00', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '09:01', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:02', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '09:03', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:04', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:05', p50: 2, p95: 8, p99: 22, avg: 4 },
      { time: '09:06', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '09:07', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:08', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '09:09', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:10', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:11', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '09:12', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:13', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '09:14', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:15', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:16', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '09:17', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:18', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '09:19', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:20', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:21', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '09:22', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:23', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '09:24', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:25', p50: 3, p95: 12, p99: 28, avg: 6 },
      { time: '09:26', p50: 0, p95: 3, p99: 6, avg: 1 },
      { time: '09:27', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:28', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '09:29', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:30', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:31', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '09:32', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:33', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '09:34', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:35', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:36', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '09:37', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:38', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '09:39', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:40', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:41', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '09:42', p50: 1, p95: 5, p99: 18, avg: 3 },
      { time: '09:43', p50: 3, p95: 15, p99: 32, avg: 7 },
      { time: '09:44', p50: 0, p95: 3, p99: 6, avg: 1 },
      { time: '09:45', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '09:46', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:47', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:48', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '09:49', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:50', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '09:51', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:52', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:53', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '09:54', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:55', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '09:56', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:57', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '09:58', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '09:59', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:00', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '10:01', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:02', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:03', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '10:04', p50: 6, p95: 18, p99: 48, avg: 10 },
      { time: '10:05', p50: 8, p95: 25, p99: 62, avg: 14 },
      { time: '10:06', p50: 1, p95: 4, p99: 8, avg: 2 },
      { time: '10:07', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '10:08', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '10:09', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:10', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:11', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '10:12', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:13', p50: 4, p95: 14, p99: 38, avg: 8 },
      { time: '10:14', p50: 0, p95: 2, p99: 5, avg: 1 },
      { time: '10:15', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '10:16', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:17', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:18', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '10:19', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:20', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '10:21', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:22', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:23', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '10:24', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:25', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '10:26', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:27', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:28', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '10:29', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:30', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '10:31', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:32', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:33', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '10:34', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:35', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '10:36', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:37', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:38', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '10:39', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:40', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '10:41', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:42', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:43', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '10:44', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:45', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '10:46', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:47', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:48', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '10:49', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:50', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '10:51', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:52', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:53', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '10:54', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:55', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '10:56', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:57', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '10:58', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '10:59', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:00', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '11:01', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:02', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:03', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '11:04', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:05', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '11:06', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:07', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:08', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '11:09', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:10', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '11:11', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:12', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:13', p50: 2, p95: 9, p99: 20, avg: 4 },
      { time: '11:14', p50: 0, p95: 2, p99: 5, avg: 1 },
      { time: '11:15', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:16', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '11:17', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:18', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:19', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '11:20', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:21', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '11:22', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:23', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:24', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '11:25', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:26', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '11:27', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:28', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:29', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '11:30', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:31', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '11:32', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:33', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:34', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '11:35', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:36', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '11:37', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:38', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:39', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '11:40', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:41', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '11:42', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:43', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:44', p50: 1, p95: 4, p99: 12, avg: 2 },
      { time: '11:45', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '11:46', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:47', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '11:48', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:49', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:50', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '11:51', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:52', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '11:53', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:54', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:55', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '11:56', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:57', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '11:58', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '11:59', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:00', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '12:01', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:02', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '12:03', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:04', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:05', p50: 5, p95: 16, p99: 42, avg: 9 },
      { time: '12:06', p50: 7, p95: 22, p99: 55, avg: 12 },
      { time: '12:07', p50: 1, p95: 5, p99: 15, avg: 3 },
      { time: '12:08', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '12:09', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '12:10', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:11', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:12', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '12:13', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:14', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '12:15', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:16', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:17', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '12:18', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:19', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '12:20', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:21', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:22', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '12:23', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:24', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '12:25', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:26', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:27', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '12:28', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:29', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '12:30', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:31', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:32', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '12:33', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:34', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '12:35', p50: 3, p95: 10, p99: 26, avg: 5 },
      { time: '12:36', p50: 0, p95: 3, p99: 8, avg: 1 },
      { time: '12:37', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:38', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:39', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '12:40', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:41', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '12:42', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:43', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:44', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '12:45', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:46', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '12:47', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:48', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:49', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '12:50', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:51', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '12:52', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:53', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:54', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '12:55', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:56', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '12:57', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:58', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '12:59', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '13:00', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:01', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '13:02', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:03', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:04', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '13:05', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:06', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '13:07', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:08', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:09', p50: 2, p95: 7, p99: 18, avg: 3 },
      { time: '13:10', p50: 0, p95: 2, p99: 6, avg: 1 },
      { time: '13:11', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:12', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '13:13', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:14', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:15', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '13:16', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:17', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '13:18', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:19', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:20', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '13:21', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:22', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '13:23', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:24', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:25', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '13:26', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:27', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '13:28', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:29', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:30', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '13:31', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:32', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '13:33', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:34', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:35', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '13:36', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:37', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '13:38', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:39', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:40', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '13:41', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:42', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '13:43', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:44', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:45', p50: 1, p95: 5, p99: 16, avg: 2 },
      { time: '13:46', p50: 0, p95: 2, p99: 5, avg: 1 },
      { time: '13:47', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:48', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '13:49', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:50', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:51', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '13:52', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:53', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '13:54', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:55', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:56', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '13:57', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '13:58', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '13:59', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '14:00', p50: 0, p95: 1, p99: 2, avg: 0 }
    ],
    "Last 24h": [
      { time: '00:00', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '00:15', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '00:30', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '00:45', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '01:00', p50: 0, p95: 0, p99: 2, avg: 0 },
      { time: '01:15', p50: 0, p95: 0, p99: 1, avg: 0 },
      { time: '01:30', p50: 0, p95: 0, p99: 1, avg: 0 },
      { time: '01:45', p50: 0, p95: 0, p99: 1, avg: 0 },
      { time: '02:00', p50: 0, p95: 0, p99: 1, avg: 0 },
      { time: '02:15', p50: 0, p95: 0, p99: 1, avg: 0 },
      { time: '02:30', p50: 0, p95: 0, p99: 1, avg: 0 },
      { time: '02:45', p50: 0, p95: 0, p99: 1, avg: 0 },
      { time: '03:00', p50: 0, p95: 0, p99: 1, avg: 0 },
      { time: '03:15', p50: 0, p95: 0, p99: 1, avg: 0 },
      { time: '03:30', p50: 0, p95: 0, p99: 1, avg: 0 },
      { time: '03:45', p50: 0, p95: 0, p99: 1, avg: 0 },
      { time: '04:00', p50: 0, p95: 0, p99: 1, avg: 0 },
      { time: '04:15', p50: 0, p95: 0, p99: 1, avg: 0 },
      { time: '04:30', p50: 0, p95: 0, p99: 1, avg: 0 },
      { time: '04:45', p50: 0, p95: 0, p99: 0, avg: 0 },
      { time: '05:00', p50: 0, p95: 0, p99: 0, avg: 0 },
      { time: '05:15', p50: 0, p95: 0, p99: 0, avg: 0 },
      { time: '05:30', p50: 0, p95: 0, p99: 1, avg: 0 },
      { time: '05:45', p50: 0, p95: 0, p99: 1, avg: 0 },
      { time: '06:00', p50: 0, p95: 0, p99: 1, avg: 0 },
      { time: '06:15', p50: 0, p95: 0, p99: 1, avg: 0 },
      { time: '06:30', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '06:45', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '07:00', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '07:15', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '07:30', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '07:45', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:00', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:15', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '08:30', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '08:45', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '09:00', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '09:15', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '09:30', p50: 0, p95: 3, p99: 6, avg: 1 },
      { time: '09:45', p50: 1, p95: 3, p99: 7, avg: 1 },
      { time: '10:00', p50: 1, p95: 4, p99: 8, avg: 1 },
      { time: '10:15', p50: 2, p95: 6, p99: 15, avg: 3 },
      { time: '10:30', p50: 3, p95: 10, p99: 25, avg: 5 },
      { time: '10:45', p50: 1, p95: 5, p99: 12, avg: 2 },
      { time: '11:00', p50: 1, p95: 4, p99: 10, avg: 1 },
      { time: '11:15', p50: 0, p95: 3, p99: 8, avg: 1 },
      { time: '11:30', p50: 0, p95: 3, p99: 7, avg: 1 },
      { time: '11:45', p50: 0, p95: 3, p99: 6, avg: 1 },
      { time: '12:00', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '12:15', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '12:30', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '12:45', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '13:00', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '13:15', p50: 0, p95: 3, p99: 6, avg: 1 },
      { time: '13:30', p50: 1, p95: 3, p99: 7, avg: 1 },
      { time: '13:45', p50: 1, p95: 4, p99: 10, avg: 1 },
      { time: '14:00', p50: 2, p95: 6, p99: 15, avg: 2 },
      { time: '14:15', p50: 2, p95: 7, p99: 18, avg: 3 },
      { time: '14:30', p50: 3, p95: 9, p99: 22, avg: 4 },
      { time: '14:45', p50: 4, p95: 12, p99: 30, avg: 6 },
      { time: '15:00', p50: 5, p95: 15, p99: 35, avg: 7 },
      { time: '15:15', p50: 6, p95: 18, p99: 42, avg: 9 },
      { time: '15:30', p50: 8, p95: 24, p99: 55, avg: 12 },
      { time: '15:45', p50: 10, p95: 30, p99: 68, avg: 15 },
      { time: '16:00', p50: 12, p95: 35, p99: 75, avg: 18 },
      { time: '16:15', p50: 9, p95: 28, p99: 65, avg: 14 },
      { time: '16:30', p50: 7, p95: 22, p99: 52, avg: 11 },
      { time: '16:45', p50: 5, p95: 18, p99: 40, avg: 8 },
      { time: '17:00', p50: 4, p95: 14, p99: 32, avg: 6 },
      { time: '17:15', p50: 3, p95: 10, p99: 25, avg: 4 },
      { time: '17:30', p50: 2, p95: 7, p99: 18, avg: 3 },
      { time: '17:45', p50: 1, p95: 5, p99: 12, avg: 2 },
      { time: '18:00', p50: 1, p95: 4, p99: 10, avg: 1 },
      { time: '18:15', p50: 0, p95: 3, p99: 8, avg: 1 },
      { time: '18:30', p50: 0, p95: 3, p99: 7, avg: 1 },
      { time: '18:45', p50: 0, p95: 2, p99: 6, avg: 0 },
      { time: '19:00', p50: 0, p95: 2, p99: 5, avg: 0 },
      { time: '19:15', p50: 0, p95: 2, p99: 4, avg: 0 },
      { time: '19:30', p50: 0, p95: 1, p99: 4, avg: 0 },
      { time: '19:45', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '20:00', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '20:15', p50: 0, p95: 1, p99: 3, avg: 0 },
      { time: '20:30', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '20:45', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '21:00', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '21:15', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '21:30', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '21:45', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '22:00', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '22:15', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '22:30', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '22:45', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '23:00', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '23:15', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '23:30', p50: 0, p95: 1, p99: 2, avg: 0 },
      { time: '23:45', p50: 0, p95: 1, p99: 2, avg: 0 }
    ]
  }

  // Sample data for Calls over time chart - extracted from Pritunl Users connected CSV data with realistic variation
  // Now structured with different time ranges similar to timeSeriesData
  type CallsDataPoint = {
    time: string;
    calls: number;
  };

  interface CallsOverTimeData {
    [key: string]: CallsDataPoint[];
  }

  const callsOverTimeData: CallsOverTimeData = {
    "Last 10m": [
      { time: '08:00', calls: 35 }, { time: '08:01', calls: 36 }, { time: '08:02', calls: 37 }, 
      { time: '08:03', calls: 38 }, { time: '08:04', calls: 39 }, { time: '08:05', calls: 40 }, 
      { time: '08:06', calls: 41 }, { time: '08:07', calls: 42 }, { time: '08:08', calls: 43 }, 
      { time: '08:09', calls: 44 }, { time: '08:10', calls: 45 }
    ],
    "Last 30m": [
      { time: '07:45', calls: 30 }, { time: '07:48', calls: 31 }, { time: '07:51', calls: 32 }, 
      { time: '07:54', calls: 33 }, { time: '07:57', calls: 34 }, { time: '08:00', calls: 35 }, 
      { time: '08:03', calls: 38 }, { time: '08:06', calls: 41 }, { time: '08:09', calls: 44 }, 
      { time: '08:12', calls: 46 }, { time: '08:15', calls: 48 }
    ],
    "Last 1h": [
      { time: '07:00', calls: 18 }, { time: '07:05', calls: 19 }, { time: '07:10', calls: 20 }, 
      { time: '07:15', calls: 21 }, { time: '07:20', calls: 23 }, { time: '07:25', calls: 24 }, 
      { time: '07:30', calls: 25 }, { time: '07:35', calls: 27 }, { time: '07:40', calls: 29 }, 
      { time: '07:45', calls: 30 }, { time: '07:50', calls: 32 }, { time: '07:55', calls: 34 }, 
      { time: '08:00', calls: 35 }, { time: '08:05', calls: 38 }, { time: '08:10', calls: 40 }, 
      { time: '08:15', calls: 41 }, { time: '08:20', calls: 43 }, { time: '08:25', calls: 45 }, 
      { time: '08:30', calls: 48 }, { time: '08:35', calls: 50 }, { time: '08:40', calls: 52 }, 
      { time: '08:45', calls: 56 }, { time: '08:50', calls: 60 }, { time: '08:55', calls: 63 },
      { time: '09:00', calls: 65 }
    ],
    "Last 6h": [
      { time: '03:00', calls: 25 }, { time: '03:15', calls: 23 }, { time: '03:30', calls: 22 }, 
      { time: '03:45', calls: 20 }, { time: '04:00', calls: 18 }, { time: '04:15', calls: 16 }, 
      { time: '04:30', calls: 15 }, { time: '04:45', calls: 13 }, { time: '05:00', calls: 12 }, 
      { time: '05:15', calls: 11 }, { time: '05:30', calls: 10 }, { time: '05:45', calls: 9 }, 
      { time: '06:00', calls: 8 }, { time: '06:15', calls: 10 }, { time: '06:30', calls: 12 }, 
      { time: '06:45', calls: 15 }, { time: '07:00', calls: 18 }, { time: '07:15', calls: 21 }, 
      { time: '07:30', calls: 25 }, { time: '07:45', calls: 30 }, { time: '08:00', calls: 35 }, 
      { time: '08:15', calls: 41 }, { time: '08:30', calls: 48 }, { time: '08:45', calls: 56 }, 
      { time: '09:00', calls: 65 }
    ],
    "Last 24h": [
      { time: '00:00', calls: 45 }, { time: '01:00', calls: 38 }, { time: '02:00', calls: 32 }, 
      { time: '03:00', calls: 25 }, { time: '04:00', calls: 18 }, { time: '05:00', calls: 12 }, 
      { time: '06:00', calls: 8 }, { time: '07:00', calls: 18 }, { time: '08:00', calls: 35 }, 
      { time: '09:00', calls: 65 }, { time: '10:00', calls: 95 }, { time: '11:00', calls: 118 }, 
      { time: '12:00', calls: 132 }, { time: '13:00', calls: 135 }, { time: '14:00', calls: 148 }, 
      { time: '15:00', calls: 156 }, { time: '16:00', calls: 162 }, { time: '17:00', calls: 148 }, 
      { time: '18:00', calls: 125 }, { time: '19:00', calls: 98 }, { time: '20:00', calls: 72 }, 
      { time: '21:00', calls: 65 }, { time: '22:00', calls: 58 }, { time: '23:00', calls: 52 }
    ]
  };

  // Define the type for pie chart data
  type PieDataPoint = {
    name: string;
    value: number;
    color: string;
  };

  interface PieDataSets {
    [key: string]: PieDataPoint[];
  }

  // Different pie chart data based on time range
  const pieDataSets: PieDataSets = {
    "Last 10m": [
      { name: 'Desktop', value: 68, color: '#6366f1' },
      { name: 'Mobile', value: 28, color: '#10b981' },
      { name: 'Tablet', value: 4, color: '#f59e0b' },
    ],
    "Last 30m": [
      { name: 'Desktop', value: 65, color: '#6366f1' },
      { name: 'Mobile', value: 30, color: '#10b981' },
      { name: 'Tablet', value: 5, color: '#f59e0b' },
    ],
    "Last 1h": [
      { name: 'Desktop', value: 72, color: '#6366f1' },
      { name: 'Mobile', value: 24, color: '#10b981' },
      { name: 'Tablet', value: 4, color: '#f59e0b' },
    ],
    "Last 6h": [
      { name: 'Desktop', value: 58, color: '#6366f1' },
      { name: 'Mobile', value: 38, color: '#10b981' },
      { name: 'Tablet', value: 4, color: '#f59e0b' },
    ],
    "Last 24h": [
      { name: 'Desktop', value: 45, color: '#6366f1' },
      { name: 'Mobile', value: 48, color: '#10b981' },
      { name: 'Tablet', value: 7, color: '#f59e0b' },
    ],
  };

  // Get the data for the selected time range or fallback to 'Last 1h' if not found
  const getTimeSeriesDataForRange = (range: string): TimeSeriesDataPoint[] => {
    return timeSeriesData[range] || timeSeriesData['Last 1h'];
  };

  // Get calls over time data for the selected time range or fallback to 'Last 1h' if not found
  const getCallsDataForRange = (range: string): CallsDataPoint[] => {
    return callsOverTimeData[range] || callsOverTimeData['Last 1h'];
  };

  // Get pie data for the selected time range or fallback to 'Last 1h' if not found
  const getPieDataForRange = (range: string): PieDataPoint[] => {
    return pieDataSets[range] || pieDataSets['Last 1h'];
  };

  return (
    <div className="charts-grid">
      <ChartCard
        title="Response Time Latency"
        type="line"
        data={getTimeSeriesDataForRange(timeRange)}
        className="chart-large"
      />
      <ChartCard
        title="Device Distribution"
        type="pie"
        data={getPieDataForRange(timeRange)}
        className="chart-small"
      />
      <ChartCard
        title="Calls over time"
        type="line"
        data={getCallsDataForRange(timeRange)}
        className="chart-medium"
      />
      <ChartCard
        title="Average Response Time"
        type="area"
        data={getTimeSeriesDataForRange(timeRange)}
        className="chart-medium"
      />
    </div>
  );
};

export default ChartsGrid;
